<template>
  <div>
    <van-nav-bar :title="generateCustomizeString('orderDetails')" :left-text="generateCustomizeString('goBack')" left-arrow @click-left="onClickLeft" />
    <div style="width: 100%; padding-bottom: 50px;">
      <van-row>
        <div class="order-head" v-if="this.orderDetailData.status === 10 || this.orderDetailData.status === 15 || this.orderDetailData.status === 20">
          <van-col span="12">{{this.orderDetailData.out_trade_no}}
          </van-col>
          <van-col span="12" style="text-align: right;">
            <span style="text-align: right; color: #ffa800; font-size: 12px;">{{generateCustomizeString(this.orderDetailData.status_name)}}</span>
          </van-col>
          <van-col span="24" style="margin-top: 5px;">
            <van-col v-if="this.orderDetailData.is_pick_up === 0">
              <van-col span="">
                <van-button type="default" size="small" @click="goOperation">{{generateCustomizeString('addExpressNo')}}</van-button>
              </van-col>
              <van-col span="" style="padding-left: 10px;">
                <van-button type="default" size="small" @click="goOperation">{{generateCustomizeString('uploadImg')}}</van-button>
              </van-col>
            </van-col>
            <van-col v-else>
              <van-button type="default" size="small" @click="writeOffClick">{{generateCustomizeString('writeOffButton')}}</van-button>
            </van-col>
            <van-col span="" style="padding-left: 10px;">
              <van-button type="default" size="small" @click="checkOrder" v-if="this.orderDetailData.status === 15">{{generateCustomizeString('checkOrder')}}</van-button>
            </van-col>
          </van-col>
        </div>
        <div class="order-id" v-else>
          <van-col span="11">{{this.orderDetailData.out_trade_no}}
          </van-col>
          <van-col span="13" style="text-align: right;">
            <span style="text-align: right; color: #ffa800; font-size: 12px;">{{generateCustomizeString(this.orderDetailData.status_name)}}</span>
          </van-col>
        </div>
        <div v-if="this.orderDetailData.status === 10 || this.orderDetailData.status === 15 || this.orderDetailData.status === 20">
          <van-tabs class="order-tabs" v-model="activeTab" sticky :offset-top=0 :ellipsis=false :line-width=60>
            <van-tab :title="generateCustomizeString('orderDetails')">
              <order-info :orderDetailData="orderDetailData" :orderTransaction="orderTransaction" :orderAddress="orderAddress" :orderSender="orderSender" :wechatDetail="wechatDetail" :orderFeeDetail="orderFeeDetail"></order-info>
            </van-tab>
            <van-tab :title="generateCustomizeString('orderOperation')" v-if="this.orderDetailData.is_pick_up === 0">
              <order-operation ref="orderOperation" v-bind:expressCompanyOptions="expressCompanyOptions" v-bind:orderExpressData="orderExpressData" v-bind:orderDetailData="orderDetailData"></order-operation>
            </van-tab>
            <van-tab :title="generateCustomizeString('statusOperation')">
              <order-status ref="orderStatus" v-bind:orderStatusProps="orderStatus" v-bind:orderDetailData="orderDetailData" v-bind:poliPaidTransaction="poliPaidTransaction"></order-status>
            </van-tab>
            <van-tab :title="generateCustomizeString('toCustomer')">
              <to-customer ref="toCustomer" v-bind:orderDetailData="orderDetailData"></to-customer>
            </van-tab>
            <van-tab :title="generateCustomizeString('goodsList')">
              <goods-list v-bind:orderProductData="orderProductData" v-bind:orderDetailData="orderDetailData"></goods-list>
            </van-tab>
            <van-tab :title="generateCustomizeString('expressInfo')" v-if="this.orderDetailData.is_pick_up === 0">
              <express-info v-bind:orderExpressData="orderExpressData"></express-info>
            </van-tab>
            <van-tab :title="generateCustomizeString('orderAttachment')" v-if="this.orderDetailData.is_pick_up === 0">
              <order-attachment v-bind:imageList="imageList"></order-attachment>
            </van-tab>
            <van-tab :title="generateCustomizeString('operationLog')">
              <operation-log v-bind:orderOperationLog="orderOperationLog"></operation-log>
            </van-tab>
          </van-tabs>
          <div style="position: fixed; bottom: 0; width: 100%;" v-if="activeTab === 1 || activeTab === 2 || activeTab === 3">
            <van-button type="primary" size="large" @click="orderOperation">{{generateCustomizeString('updateOrder')}}</van-button>
          </div>
        </div>
        <div v-else>
          <van-tabs class="order-tabs" v-model="activeTab" sticky :offset-top=0 :ellipsis=false :line-width=60>
            <van-tab :title="generateCustomizeString('orderDetails')">
              <order-info v-bind:orderDetailData="orderDetailData" v-bind:orderTransaction="orderTransaction" v-bind:orderAddress="orderAddress" v-bind:orderSender="orderSender" v-bind:wechatDetail="wechatDetail" v-bind:orderFeeDetail="orderFeeDetail"></order-info>
            </van-tab>
            <van-tab :title="generateCustomizeString('statusOperation')">
              <order-status ref="orderStatus" v-bind:orderStatusProps="orderStatus" v-bind:orderDetailData="orderDetailData" v-bind:poliPaidTransaction="poliPaidTransaction"></order-status>
            </van-tab>
            <van-tab :title="generateCustomizeString('toCustomer')">
              <to-customer ref="toCustomer" v-bind:orderDetailData="orderDetailData"></to-customer>
            </van-tab>
            <van-tab :title="generateCustomizeString('goodsList')">
              <goods-list v-bind:orderProductData="orderProductData" v-bind:orderDetailData="orderDetailData"></goods-list>
            </van-tab>
            <van-tab :title="generateCustomizeString('expressInfo')" v-if="this.orderDetailData.is_pick_up === 0">
              <express-info v-bind:orderExpressData="orderExpressData"></express-info>
            </van-tab>
            <van-tab :title="generateCustomizeString('orderAttachment')" v-if="this.orderDetailData.is_pick_up === 0">
              <order-attachment v-bind:imageList="imageList"></order-attachment>
            </van-tab>
            <van-tab :title="generateCustomizeString('operationLog')">
              <operation-log v-bind:orderOperationLog="orderOperationLog"></operation-log>
            </van-tab>
          </van-tabs>
          <div style="position: fixed; bottom: 0; width: 100%;" v-if="activeTab === 1 || activeTab === 2">
            <van-button type="primary" size="large" @click="orderOperation">{{generateCustomizeString('updateOrder')}}</van-button>
          </div>
        </div>
      </van-row>
    </div>

    <van-dialog
      v-model="writeOffDialog"
      show-cancel-button
      :confirmButtonText="generateCustomizeString('confirm')"
      :cancelButtonText="generateCustomizeString('cancel')"
      :title="generateCustomizeString('writeOffTitle')"
      @confirm="writeOffConfirm"
    >
    </van-dialog>
  </div>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import { Row, Col, Uploader, Icon, NavBar, Tabbar, TabbarItem, Tab, Tabs, Button, Cell, CellGroup, Tag, Dialog, Toast } from 'vant'
import OrderInfo from './OrderInfo'
import GoodsList from './GoodsList'
import ExpressInfo from './ExpressInfo'
import OrderOperation from './OrderOperation'
import OrderAttachment from './OrderAttachment'
import OperationLog from './OperationLog'
import OrderStatus from './OrderStatus'
import ToCustomer from './ToCustomer'
import request from '@/utils/request'
import dayjs from 'dayjs'

export default {
  name: 'OrderDetail',
  components: {
    [Uploader.name]: Uploader,
    [Icon.name]: Icon,
    [NavBar.name]: NavBar,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Row.name]: Row,
    [Col.name]: Col,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tag.name]: Tag,
    [Dialog.name]: Dialog,
    [Toast.name]: Toast,
    OrderInfo,
    GoodsList,
    ExpressInfo,
    OrderOperation,
    OrderAttachment,
    OperationLog,
    OrderStatus,
    ToCustomer
  },
  data() {
    return {
      active: 0,
      activeTab: 0,
      imgLink: 'https://img.nzmai.com.cn/000robbme4_1537254820869.jpg',
      orderDetailData: {},
      orderTransaction: [],
      orderAddress: {},
      orderSender: {},
      orderExpressData: [],
      orderProductData: [],
      orderOperationLog: [],
      expressCompanyOptions: [],
      wechatDetail: {},
      imageList: [],
      imgListKey: [],
      updateStatusDialog: false,
      orderStatus: null,
      imageKeys: [],
      orderFeeDetail: {},
      writeOffDialog: false,
      poliPaidTransaction: null
    }
  },
  methods: {
    generateCustomizeString,
    onClickLeft() {
      this.$router.replace({ name: 'Orders' })
    },
    goOperation() {
      this.activeTab = 1
    },
    getOperationStatus(status) {
      var statusName = ''
      switch (status) {
        case 1:
          statusName = this.generateCustomizeString('orderStatus')
          break
        case 2:
          statusName = this.generateCustomizeString('orderValue')
          break
        case 3:
          statusName = this.generateCustomizeString('others')
          break
        default:
          statusName = this.generateCustomizeString('others')
      }
      return statusName
    },
    checkOrder() {
      this.$router.push({
        name: 'OrderCheck',
        params: { orderId: this.orderDetailData.id }
      })
    },
    fetchOrderInfo() {
      // const that = this
      return new Promise((resolve, reject) => {
        request({
          url: 'order/' + this.$route.params.orderId,
          method: 'get'
        })
          .then(response => {
            const orderData = response.data
            const orderTransactionData = response.data.transactions
            const orderAddressData = response.data.order_address
            const orderSenderData = response.data.order_sender
            var orderFeeDetailData = {}
            if (response.data.is_agent_order === true) {
              orderFeeDetailData = response.data.order_cost_fee_detail
            } else {
              orderFeeDetailData = response.data.order_fee_detail
            }

            this.orderDetailData = orderData
            this.orderTransaction = orderTransactionData
            this.orderAddress = orderAddressData
            this.orderSender = orderSenderData
            this.orderFeeDetail = orderFeeDetailData

            this.orderStatus = response.data.status

            if (this.orderDetailData.delivery_at) {
              this.orderDetailData.delivery_at = this.orderDetailData.delivery_at.replace(/-/g, '/')
              this.orderDetailData.delivery_at = dayjs(new Date(this.orderDetailData.delivery_at + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
            }
            if (this.orderDetailData.created_at) {
              this.orderDetailData.created_at = this.orderDetailData.created_at
            }
            if (this.orderDetailData.finished_at) {
              this.orderDetailData.finished_at = this.orderDetailData.finished_at.replace(/-/g, '/')
              this.orderDetailData.finished_at = dayjs(new Date(this.orderDetailData.finished_at + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
            }
            if (this.orderDetailData.paid_at) {
              this.orderDetailData.paid_at = this.orderDetailData.paid_at.replace(/-/g, '/')
              this.orderDetailData.paid_at = dayjs(new Date(this.orderDetailData.paid_at + ' UTC')).format('YYYY-MM-DD HH:mm:ss')
            }
            if (response.data.customer.wechat_auths.length && response.data.customer.wechat_auths[0].user_info) {
              this.wechatDetail = response.data.customer.wechat_auths[0].user_info
            }
            if (response.data.customer) {
              this.wechatDetail.remark = response.data.customer.remark
            }

            // Order fee details
            if (this.orderFeeDetail) {
              this.orderFeeDetail.total_goods_fee =
                parseFloat((this.orderFeeDetail.total_goods_fee * 100) / 10000).toFixed(2)
              this.orderFeeDetail.total_activity_reduction =
                parseFloat((this.orderFeeDetail.total_activity_reduction * 100) / 10000).toFixed(2)
              this.orderFeeDetail.total_goods_fee_after_discounted =
                parseFloat((this.orderFeeDetail.total_goods_fee_after_discounted * 100) / 10000).toFixed(2)
              this.orderFeeDetail.total_express_fee =
                parseFloat((this.orderFeeDetail.total_express_fee * 100) / 10000).toFixed(2)
              this.orderFeeDetail.total_express_fee_after_discounted =
                parseFloat((this.orderFeeDetail.total_express_fee_after_discounted * 100) / 10000).toFixed(2)
              this.orderFeeDetail.total_express_fee_reduction =
                parseFloat(this.orderFeeDetail.total_express_fee - this.orderFeeDetail.total_express_fee_after_discounted).toFixed(2)
              this.orderFeeDetail.total_coupon_reduction =
                parseFloat((this.orderFeeDetail.total_coupon_reduction * 100) / 10000).toFixed(2)
              this.orderFeeDetail.total_fee_after_discounted =
                parseFloat((this.orderFeeDetail.total_fee_after_discounted * 100) / 10000).toFixed(2)
              this.orderFeeDetail.profit = parseFloat((response.data.profit * 100) / 10000).toFixed(2)
              this.orderFeeDetail.fee = parseFloat((response.data.fee * 100) / 10000).toFixed(2)
              this.orderFeeDetail.use_activity_list = this.orderFeeDetail.detail_json.use_activity_list
              this.orderFeeDetail.use_coupon_list = this.orderFeeDetail.detail_json.use_coupon_list
            }
            console.log(this.orderFeeDetail)

            // Expresses
            const orderExpresses = []
            if (response.data.expresses.length > 0) {
              for (var e = 0; e < response.data.expresses.length; e++) {
                var eobj = {}
                eobj.id = response.data.expresses[e].id
                if (response.data.expresses[e].express_company && response.data.expresses[e].express_company_id > 0) {
                  eobj.expressCompanyId = response.data.expresses[e].express_company_id
                  eobj.expressCompany = response.data.expresses[e].express_company.name
                  eobj.queryUrl = response.data.expresses[e].express_company.order_query_url
                } else {
                  eobj.expressCompanyId = null
                  eobj.expressCompany = ''
                  eobj.queryUrl = ''
                }
                eobj.expressNumber = response.data.expresses[e].express_number

                orderExpresses[e] = eobj
              }
            }
            this.orderExpressData = orderExpresses

            // Product Data
            const orderGoods = response.data.order_goods
            const data = orderGoods

            for (let i = 0; i < orderGoods.length; i++) {
              var obj = {}
              if (orderGoods[i].first_image_url) {
                obj.productThumbnailUrl =
                  orderGoods[i].first_image_url +
                  '?imageView2/0/w/128/h/128/q/75|imageslim'
              }
              obj.productTitle = orderGoods[i].product_full_name
              obj.productId = orderGoods[i].bar_code
              if (orderGoods[i].best_use_before_at !== null) {
                obj.bestBefore = orderGoods[i].best_use_before_at
              } else {
                obj.bestBefore = this.generateCustomizeString('new')
              }
              obj.unitPrice = 'NZD $' + parseFloat(orderGoods[i].order_price / 100).toFixed(2)
              obj.amount = orderGoods[i].quantity
              obj.total =
                'NZD $' +
                parseFloat(orderGoods[i].order_price * orderGoods[i].quantity / 100).toFixed(2)

              data[i] = obj
            }
            this.orderProductData = data
            console.log(this.orderExpressData)

            // images
            const images = response.data.images
            for (let i = 0; i < images.length; i++) {
              this.imageList.push(images[i].image_url + '?imageView2/0/w/500/q/75|imageslim')
              this.imgListKey.push(images[i].qiniu_res_key)
            }

            console.log(this.imageList)
            console.log(this.orderDetailData)

            // Operation Log
            const logData = response.data.order_operation_logs
            for (
              let i = 0;
              i < response.data.order_operation_logs.length;
              i++
            ) {
              var sobj = {}
              sobj.operator = response.data.order_operation_logs[i].operator
              sobj.operatingTime = response.data.order_operation_logs[i].created_at
              // sobj.operatingTime = response.data.order_operation_logs[i].created_at
              sobj.operationalAttributes = this.getOperationStatus(response.data.order_operation_logs[i].status)
              sobj.operationDetails =
                response.data.order_operation_logs[i].message
              sobj.operationNotes =
                response.data.order_operation_logs[i].comments

              logData[i] = sobj
            }
            this.orderOperationLog = logData.reverse()

            for (var t = 0; t < this.orderTransaction.length; t++) {
              const transaction = this.orderTransaction[t]
              if (
                this.poliPaidTransaction === null &&
                transaction.pay_type === 'IE0041' &&
                transaction.status === 1
              ) {
                this.poliPaidTransaction = transaction
              }
            }
            Toast.clear()
            resolve()
          })
          .catch(error => {
            Toast.clear()
            console.warn(error)
            reject(error)
          })
      })
    },
    fetchExpressCompany() {
      return new Promise((resolve, reject) => {
        request({
          url: '/express/shop/company/list',
          method: 'get'
        })
          .then(response => {
            const data = response.data
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              obj.value = response.data[i].express_company_id
              obj.name = response.data[i].company.name
              obj.is_default = response.data[i].is_default
              data[i] = obj
            }
            this.expressCompanyOptions = data
            resolve()
          })
          .catch(error => {
            // console.warn(error)
            reject(error)
          })
      })
    },
    orderOperation() {
      // const that = this
      Dialog.confirm({
        title: this.generateCustomizeString('updateOrder'),
        message: this.generateCustomizeString('confirmUpdateOrder'),
        confirmButtonText: this.generateCustomizeString('confirm'),
        cancelButtonText: this.generateCustomizeString('cancel')
      }).then(() => {
        for (var j = 0; j < this.orderDetailData.images.length; j++) {
          this.imageKeys.push(this.orderDetailData.images[j].qiniu_res_key)
        }
        var data = {
          expresses: this.orderDetailData.expresses,
          upload_image_keys: this.imageKeys,
          status: this.orderDetailData.status,
          // is_refunded_to_credits: false,
          comments: '',
          to_customer_message: this.orderDetailData.to_customer_message,
          refund_type: ''
        }
        if (this.$refs.orderOperation) {
          data.expresses = this.$refs.orderOperation.expresses
          data.upload_image_keys = this.$refs.orderOperation.imageKeys
          // data.status = this.orderDetailData.status
          // data.is_refunded_to_credits = false
          // data.comments = ''
        }
        if (this.orderDetailData.is_agent_order === true) {
          this.$refs.orderStatus.refundType = '2' // refundToOPM
        }
        if (this.$refs.orderStatus) {
          // data.expresses = this.orderDetailData.expresses
          // data.upload_image_keys = this.imageKeys
          data.status = this.$refs.orderStatus.orderStatus
          data.refund_type = this.$refs.orderStatus.refundType
          data.comments = this.$refs.orderStatus.operationNotes
        }
        if (this.$refs.toCustomer) {
          data.to_customer_message = this.$refs.toCustomer.toCustomer
        }

        request({
          url: 'order/' + this.$route.params.orderId,
          method: 'put',
          data
        })
          .then(response => {
            if (response.status === 40047) {
              Toast.fail(
                this.generateCustomizeString('MyPayAccountBalanceNotEnough')
              )
              return
            }
            if (response.status === 0) {
              // 增加一些空值判断， 来避免我看不懂的代码的判断
              if (this.$refs && this.$refs.orderStatus && this.$refs.orderStatus.hasOwnProperty('refundType')) {
                if (this.$refs.orderStatus.refundType == '2' && this.poliPaidTransaction && this.$refs.orderStatus.orderStatus == 60) {
                  Toast.success(this.generateCustomizeString('updateSuccess') + '<br/>' +
                    this.generateCustomizeString('poliPayRefundOperation') + this.poliPaidTransaction.fee / 100 + ' NZD')
                  this.fetchOrderInfo()
                  this.$router.go(0)
                } else {
                  Toast.success(this.generateCustomizeString('updateSuccess'))
                  this.fetchOrderInfo()
                  this.$router.go(0)
                }
              } else {
                Toast.success(this.generateCustomizeString('updateSuccess'))
                this.fetchOrderInfo()
                this.$router.go(0)
              }
            } else {
              Toast.fail(this.generateCustomizeString('updateFail'))
            }
          })
          .catch(error => {
            console.log(error)
            Toast.fail(this.generateCustomizeString('updateFail'))
          })
      }).catch(() => {
        // on cancel
      })
    },
    writeOffClick() {
      this.writeOffDialog = true
    },
    writeOffConfirm() {
      var data = {
        order_id: this.orderDetailData.id
      }
      request({
        url: '/write-off',
        method: 'post',
        data
      })
        .then(res => {
          if (res.status === 0) {
            Toast.success(this.generateCustomizeString('writeOffSuccessfully'))
          } else {
            Toast.fail(this.generateCustomizeString('writeOffFailed'))
          }
        })
        .catch(error => {
          console.log(error)
          Toast.fail(this.generateCustomizeString('writeOffFailed'))
        })
        .finally(() => {
          this.writeOffDialog = false
        })
    }
  },
  created: function() {
    Toast.loading({
      mask: true,
      forbidClick: true,
      message: this.generateCustomizeString('loading')
    })
    Promise.all([
      this.fetchExpressCompany()
    ])
      .then(result => {
        this.fetchOrderInfo()
      })
      .catch(error => {
        console.warn(error)
      })
    // store.dispatch('GetQiNiuUploadToken').then(token => {
    //   console.log(token)
    // })
  }
}
</script>

<style lang="less" scoped>
// .order-tabs {
//   // margin-top: 44px;
//   // z-index: 999;
// }
.order-head {
  height: 60px;
  background: #fff;
  padding: 10px;
  line-height: 1.5rem;
}
.order-id {
  // position: fixed;
  // width: 100%;
  // margin-top: 44px;
  height: 30px;
  background: #fff;
  padding: 10px;
  line-height: 1.5rem;
  // z-index: 1;
}
</style>
